import React, { useEffect, useRef } from 'react';
import './DomainesIntervention.css';

function DomainesIntervention() {
  const domaineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px'
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
          entry.target.classList.add('animated');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    domaineRefs.current.forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="domaines-intervention">
      {/* Hero Section */}
      <section className="domaines-hero">
        <div className="domaines-hero-content">
          <h1 className="title">Une Expertise Juridique au Service d'Enjeux Multiples</h1>
          <p className="text">
            Le Cabinet est pluridisciplinaire et offre des services de conseil et de représentation juridique dans un large éventail de matières juridiques.
            <br /><br />
            Le cabinet accompagne particuliers, entreprises, institutions financières et clients internationaux dans la gestion de questions juridiques complexes dans le cadre du droit tunisien.
            <br /><br />
            Son activité repose sur la combinaison de l'analyse juridique approfondie, du conseil stratégique et de la représentation devant l'ensemble des juridictions tunisiennes.
          </p>
          <img
            src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Domaines+d'interventions+Hero.png"
            alt="Domaines d'interventions"
            className="hero-image"
          />
        </div>
      </section>

      {/* Domaines Section */}
      <section className="domaines-section">
        {/* Droit commercial et droit des sociétés */}
        <div className="domaine-item" ref={el => domaineRefs.current[0] = el}>
          <div className="domaine-content">
            <h2 className="title">Droit Commercial et Droit des Sociétés</h2>
            <p className="text">
              Le cabinet conseille entreprises, entrepreneurs et investisseurs dans leurs activités commerciales et leurs opérations juridiques.
              <br /><br />
              Il intervient notamment dans la structuration juridique des activités, la rédaction et l'analyse de contrats commerciaux, ainsi que dans la gestion des différends commerciaux.
            </p>
          </div>
          <div className="domaine-image-container">
            <img
              src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Domaines+d'interventions+1.png"
              alt="Droit commercial"
            />
          </div>
        </div>

        {/* Droit fiscal */}
        <div className="domaine-item domaine-item-reverse" ref={el => domaineRefs.current[1] = el}>
          <div className="domaine-content">
            <h2 className="title">Droit Fiscal</h2>
            <p className="text">
              Le cabinet accompagne ses clients dans les questions liées à la fiscalité, y compris la conformité fiscale, l'analyse des obligations fiscales et la gestion des différends avec l'administration fiscale.
            </p>
          </div>
          <div className="domaine-image-container">
            <img
              src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Domaines+d'interventions+2.png"
              alt="Droit fiscal"
            />
          </div>
        </div>

        {/* Droit bancaire et financier */}
        <div className="domaine-item" ref={el => domaineRefs.current[2] = el}>
          <div className="domaine-content">
            <h2 className="title">Droit Bancaire et Financier</h2>
            <p className="text">
              Le cabinet conseille les institutions financières et les entreprises dans les questions juridiques liées aux opérations bancaires et financières ainsi qu'aux obligations réglementaires applicables.
            </p>
          </div>
          <div className="domaine-image-container">
            <img
              src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Domaines+d'interventions+3.png"
              alt="Droit bancaire"
            />
          </div>
        </div>

        {/* Contentieux civil et commercial */}
        <div className="domaine-item domaine-item-reverse" ref={el => domaineRefs.current[3] = el}>
          <div className="domaine-content">
            <h2 className="title">Contentieux Civil et Commercial</h2>
            <p className="text">
              Le cabinet représente ses clients dans les litiges civils et commerciaux devant les juridictions tunisiennes.
            </p>
          </div>
          <div className="domaine-image-container">
            <img
              src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Domaines+d'interventions+4.png"
              alt="Contentieux"
            />
          </div>
        </div>

        {/* Droit administratif et réglementaire */}
        <div className="domaine-item" ref={el => domaineRefs.current[4] = el}>
          <div className="domaine-content">
            <h2 className="title">Droit Administratif et Réglementaire</h2>
            <p className="text">
              Le cabinet intervient dans les affaires impliquant les autorités administratives et accompagne ses clients dans les procédures relevant du droit administratif et de la réglementation.
            </p>
          </div>
          <div className="domaine-image-container">
            <img
              src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Domaines+d'interventions+5.png"
              alt="Droit administratif"
            />
          </div>
        </div>

        {/* Arbitrage international */}
        <div className="domaine-item domaine-item-reverse" ref={el => domaineRefs.current[5] = el}>
          <div className="domaine-content">
            <h2 className="title">Arbitrage International</h2>
            <p className="text">
              Cabinet Ben Nasr intervient également dans les procédures d'arbitrage international, notamment dans le cadre de différends commerciaux transfrontaliers.
              <br /><br />
              Le cabinet accompagne ses clients dans la préparation des dossiers, l'élaboration des stratégies juridiques et la conduite des procédures arbitrales.
            </p>
          </div>
          <div className="domaine-image-container">
            <img
              src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/image+3.png"
              alt="Arbitrage"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default DomainesIntervention;
